module.exports = __webpack_public_path__ + "assets/img/IMG017.cb9b3c7e.png";